// Memorial entry for Tsachi Idan
import tsachiIdanPortrait from '../../../images/tsachi-idan.jpg';

export const tsachiIdanMemorial = {
  id: 32,
  name: 'Tsachi Idan',
  images: {
    portrait: tsachiIdanPortrait
  },
  info: `
"The terrorists promised his daughter he would return. He never did."

# Tsachi Idan

![Tsachi Idan](${tsachiIdanPortrait})
*Yitzchak "Tsachi" Idan, 50, devoted father and Hapoel Tel Aviv superfan*

## Born to Nahal Oz

Tsachi Idan was born and raised in Kibbutz Nahal Oz, the oldest of four children. After IDF service, he left but returned in 2009 with his wife Gali and their children. He worked as a DevOps engineer but his heart belonged to his family and Hapoel Tel Aviv - he held VIP season tickets and attended every match with his children.

The kibbutz remembered him as "a simple, humble guy, hiding behind his tools, but when somebody needed help, Tsachi was always there with all his heart and soul."

## October 7, 2023

At 6:29 a.m., sirens woke the Idan family. Tsachi, Gali, and their four children ran to the safe room. When terrorists demanded entry, Tsachi held the door shut. His eldest daughter Maayan, 18, jumped up to help him.

The terrorists shot through the door. Maayan was hit in the head and collapsed into her father's arms. She died there.

"When Maayan was shot, Tsachi let the door fall open, and he was broken," Gali recalled.

Terrorists livestreamed the aftermath on Gali's Facebook - Tsachi sitting stunned with bloody hands next to his younger children. When 10-year-old Shahar asked if they would kill his father, the terrorist said he would do so in another room.

At noon, Tsachi was handcuffed and taken to Gaza. Twelve-year-old Yael pleaded with them not to take him. They promised: "He'll be back."

## A Pace Away

Tsachi was still alive for the November 2023 ceasefire - "a pace away" from release, his sister said. But the deal expired. He died on December 4, 2023, murdered in captivity.

## Father and Daughter, Together

After 510 days, his body returned on February 27, 2025. The funeral was held at Bloomfield Stadium - Hapoel's home ground - with fans in red honoring their fellow supporter.

He was buried at Kibbutz Einat, next to Maayan. Father and daughter, together again.

His brother Udi: "You didn't deserve to witness Maayan's murder, you didn't deserve to be held captive by Hamas monsters."

*May his memory be a blessing.*

[Read more](https://www.timesofisrael.com/tsachi-idan-49-high-tech-worker-and-hapoel-tel-aviv-superfan/)
`
};
